/* unplugin-vue-components disabled */import { render } from "./ActivationDetail.vue?vue&type=template&id=53164225&scoped=true"
import script from "./ActivationDetail.vue?vue&type=script&lang=js"
export * from "./ActivationDetail.vue?vue&type=script&lang=js"

import "./ActivationDetail.vue?vue&type=style&index=0&id=53164225&lang=less&scoped=true"
import "./ActivationDetail.vue?vue&type=style&index=1&id=53164225&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53164225"]])

export default __exports__